import { useEffect } from 'react'
import { CustomizePrint, Navigation, EditUnauthorized } from 'components'
import { caseAtom } from 'atoms'
import { useRecoilValue } from 'recoil'
import { themeCategories } from 'mocks'
import { useDynamicStyles, useStonlyWidget, useTokenValidation } from 'hooks'
import { useCaseInfo } from 'hooks/utility/useCaseInfo'
import { isTokenizedEditSession } from '@messenger/consts'
import previewGlobal from 'styles/previewGlobal'
import { useLocation } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import { initializeSessionRecording } from 'utils/global/posthog'

export const Preview = () => {
  const caseInfo = useRecoilValue(caseAtom)
  const location = useLocation()
  const posthog = usePostHog()
  const { caseHeader } = useCaseInfo(caseInfo)

  const isMessengerAccess = isTokenizedEditSession(location.search)

  const { isValidSession, returnUrl, shouldCloseTab } =
    useTokenValidation(isMessengerAccess)

  useDynamicStyles(previewGlobal)
  useStonlyWidget()

  useEffect(() => {
    if (posthog) {
      initializeSessionRecording(posthog)
    }
  }, [posthog])

  // Show loading state while checking validation
  if (isValidSession === null) {
    return null
  }

  // Show unauthorized if validation failed
  if (isValidSession === false) {
    return (
      <EditUnauthorized
        returnUrlProp={returnUrl}
        shouldCloseTab={shouldCloseTab}
      />
    )
  }

  return (
    <>
      <Navigation type="package" />

      <CustomizePrint
        caseInfo={caseHeader}
        categories={themeCategories}
        key={location.key}
      />
    </>
  )
}

export default Preview
